var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678 1021 l-35 -30 -23 24 c-30 32 -47 31 -83 -2 l-29 -28 -22 28 c-27 34 -43 34 -78 0 l-28 -27 -28 27 c-35 34 -52 34 -82 2 l-24 -25 -27 26 c-15 14 -35 24 -46 22 -17 -3 -18 -22 -21 -358 -1 -195 0 -370 3 -389 4 -18 17 -44 30 -57 l24 -24 455 0 455 0 28 24 28 24 0 149 0 148 -152 3 -153 3 0 233 c0 193 -3 236 -15 246 -12 10 -20 6 -45 -21 l-30 -33 -34 33 -34 33 -34 -31z m-331 -73 l33 -32 33 31 32 32 34 -31 33 -30 34 33 33 32 30 -31 c16 -18 32 -32 36 -32 4 0 20 14 36 32 l30 31 32 -31 c31 -30 34 -31 55 -17 l21 16 3 -346 3 -345 -302 0 c-289 0 -303 1 -313 19 -10 21 -15 671 -4 671 3 0 12 -7 20 -15 18 -17 47 -6 67 25 15 26 15 26 54 -12z m783 -544 c0 -147 3 -144 -128 -144 -71 0 -112 4 -120 12 -8 8 -12 50 -12 125 l0 113 130 0 130 0 0 -106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 805 c-11 -30 12 -36 128 -33 106 3 114 4 114 23 0 19 -8 20 -118 23 -100 2 -118 0 -124 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 662 c-12 -4 -14 -42 -2 -43 4 0 92 -1 195 -1 131 -1 191 2 199 10 28 28 -9 35 -197 36 -102 1 -189 0 -195 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 495 c-12 -31 7 -35 195 -35 188 0 216 5 204 36 -8 21 -391 20 -399 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billingIcon.60859ad79bff04efe1389223b2444ae7.svg";
export { ForwardRef as ReactComponent };